<app-toolbar-popover
  [displayMode]="displayMode.ExpandCollapse"
  [collapsedButton]="collapsedButtonItem"
  [expandedButtons]="expandedButtonItems">
</app-toolbar-popover>

<div class="hd-icon icon-lg rc-zoom-bar"
  [class.hd-icon-hand]="!isPanEnabled()"
  [class.hd-icon-close]="isPanEnabled()"
  [class.rc-zoom-bar-item-disabled]="!isZoomed() && !isPanEnabled()"
  [soti-tooltip]="'remoteControl_btn_PanMode' | xsI18n "
  placement="left"
  (click)="pan(!isPanEnabled())">
</div>
